export default class mainNav {
  constructor() {
    this.breakPoint = '(max-width: 1279px)';
    this.navEl = document.querySelector('.main-nav');
    if (! this.navEl) return;
    this.initObserver();

    this.navMenuEl = this.navEl.querySelector('.main-nav__menu-wrapper');
    this.navToggleEl = this.navEl.querySelector('.main-nav__menu-toggle');
    if (! (this.navMenuEl || this.navToggleEl)) return;

    this.subMenus = this.navEl.querySelectorAll('.sub-menu');
    this.subMenusToggles = this.navEl.querySelectorAll('.sub-menu-toggle');
    
    this.subMenusToggles.forEach((toggle, index) => {
      toggle.setAttribute('aria-controls', `sub-menu-${index}`);
      this.subMenus[index].setAttribute('id', `sub-menu-${index}`);
    });

    this.responsiveAriaTags();

    this._bindEvents();
  }

  _bindEvents() {
    this.navToggleEl.addEventListener('click', event => {
      this.navEl.classList.toggle('has-menu-open');
      this.navToggleEl.setAttribute('aria-expanded', (this.navToggleEl.getAttribute('aria-expanded') === 'true') ? false : true);

      if (window.matchMedia(this.breakPoint).matches) {
        this.navMenuEl.setAttribute('aria-hidden', (this.navMenuEl.getAttribute('aria-hidden') === 'true') ? false : true);
      }
    });

    document.addEventListener('click', event => {
      if (this.navEl.contains(event.target)) return; // click inside menu

      this.navEl.classList.remove('has-menu-open');
      this.navToggleEl.setAttribute('aria-expanded', false);

      if (window.matchMedia(this.breakPoint).matches) {
        this.navMenuEl.setAttribute('aria-hidden', true);

        this.subMenusToggles.forEach((toggle, index) => {
          toggle.setAttribute('aria-expanded', false);
          this.subMenus[index].setAttribute('aria-hidden', true);
        });
      }
    });

    this.subMenusToggles.forEach((toggle, index) => {
      toggle.addEventListener('click', event => {
        toggle.setAttribute('aria-expanded', (toggle.getAttribute('aria-expanded') === 'true') ? false : true);
        this.subMenus[index].setAttribute('aria-hidden', (this.subMenus[index].getAttribute('aria-hidden') === 'true') ? false : true);
      });
    });

    window.addEventListener('resize', event => {
      this.responsiveAriaTags();
    });
  }
  responsiveAriaTags() {
    if (window.matchMedia(this.breakPoint).matches) {
      this.navToggleEl.disabled = false;
      this.navMenuEl.setAttribute('aria-hidden', true);

      // this.subMenusToggles.forEach((toggle, index) => {
      //   toggle.disabled = false;
      //   this.subMenus[index].setAttribute('aria-hidden', true);
      // });
    }
    else {
      this.navToggleEl.disabled = true;
      this.navMenuEl.removeAttribute('aria-hidden');
      
      // this.subMenusToggles.forEach((toggle, index) => {
      //   toggle.disabled = true;
      //   this.subMenus[index].removeAttribute('aria-hidden');
      // });
    }
    this.subMenusToggles.forEach((toggle, index) => {
      toggle.disabled = false;
      this.subMenus[index].setAttribute('aria-hidden', true);
    });
  }
  initObserver() {
    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.navEl.classList.remove('is-moving');
        }
        else {
          this.navEl.classList.add('is-moving');
        }
      });
    }, {
      threshold: 1,
      // rootMargin: "100px 0px 0px 0px",
    });
  
    this.scrollObserver.observe(this.navEl.parentElement);
  }
}


// export default class mainNav {
//   constructor(navSelector, navMenuSelector, navToggleSelector) {
//     this.navEl = document.querySelector(navSelector);
//     if (! this.navEl) return;
//     this.initObserver();

//     this.navMenuEl = this.navEl.querySelector(navMenuSelector);
//     this.navToggleEl = this.navEl.querySelector(navToggleSelector);
//     this.initMenu();

//     this.subMenuContaniners = this.navEl.querySelectorAll('.menu-item-has-children');
//     this.subMenuEls = [];
//     this.subMenuToggles = [];
//     this.initSubs();

//     // this.initProgress();
//   }

//   initObserver() {
//     this.scrollObserver = new IntersectionObserver(entries => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           this.navEl.classList.remove('is-moving');
//         }
//         else {
//           this.navEl.classList.add('is-moving');
//         }
//       });
//     }, {
//       threshold: 1,
//       // rootMargin: "100px 0px 0px 0px",
//     });
  
//     this.scrollObserver.observe(this.navEl.parentElement);
//   }
//   initMenu() {
//     if (!this.navMenuEl || !this.navToggleEl) {
//       return;
//     }

//     this.navToggleEl.addEventListener('click', event => {
//       this.navMenuEl.classList.toggle('is-open');
//       this.navEl.classList.toggle('is-main-open');
//     });

//     document.addEventListener('click', event => {
//       if (! this.navEl.contains(event.target)) {
//         console.log('click outside nav menu ');
//         this.navMenuEl.classList.remove('is-open');
//         this.navEl.classList.remove('is-main-open');
//         this.navEl.classList.remove('is-sub-open');

//         this.subMenuEls.forEach(subMenuEl => {
//           subMenuEl.classList.remove('is-open');
//         });
//       }
//     });
//   }
//   initSubs() {
//     this.subMenuContaniners.forEach(subMenuContainer => {
//       let subMenuEl = subMenuContainer.querySelector('.sub-menu');
//       // let subMenuToggle = subMenuContainer.querySelector(':scope > a');
//       let subMenuToggle = subMenuContainer.querySelector('.sub-menu-arrow');
//       this.subMenuEls.push(subMenuEl);
//       this.subMenuToggles.push(subMenuToggle);
//     });

//     this.navEl.addEventListener('click', event => {
//       let atLeastOneSubOpen = false;
//       this.subMenuContaniners.forEach((subMenuContaniner, index) => {
//         if (subMenuContaniner.contains(event.target)) {
//           if (event.target === this.subMenuToggles[index] || this.subMenuToggles[index].contains(event.target)) {
//             // event.preventDefault();
//             this.subMenuToggles[index].setAttribute('aria-expanded', ! this.subMenuEls[index].classList.contains('is-open'))
//             this.subMenuEls[index].classList.toggle('is-open');
//             atLeastOneSubOpen = true;
//             // this.navEl.classList.toggle('is-sub-open');
//           }
//         }
//         else {
//           // this.navEl.classList.remove('is-sub-open');
//           this.subMenuEls[index].classList.remove('is-open');
//           this.subMenuToggles[index].setAttribute('aria-expanded', false);
//         }

//         if (atLeastOneSubOpen) {
//           this.navEl.classList.add('is-sub-open');
//         }
//         else {
//           this.navEl.classList.remove('is-sub-open');
//         }
//       });
//     });
//   }
//   initProgress() {
//     this.progressEl = document.createElement('span');
//     this.progressEl.classList.add('main-menu-progress');
//     this.navMenuEl.appendChild(this.progressEl);
//     this.currentMenuItemLink = this.navMenuEl.querySelector('.current-menu-item > a');

//     this.changeProgress(this.currentMenuItemLink);

//     this.navMenuEl.addEventListener('mouseover', event => {
//       if (event.target.parentElement.classList.contains('menu-item')) {
//         // console.log('hovered on a element');
//         if (event.target.parentElement.classList.contains('special')) return; //contact button
//         if (event.target.classList.contains('sub-menu')) return; //sub menu element
//         if (event.target.parentElement.parentElement.classList.contains('sub-menu')) return; //sub menu a element
//         this.changeProgress(event.target);
//       }
//     });
//     this.navMenuEl.addEventListener('mouseleave', event => {
//       this.changeProgress(this.currentMenuItemLink);
//     });
//     window.addEventListener('resize', event => {
//       this.changeProgress(this.currentMenuItemLink);
//     });
//   }
//   changeProgress(menuItemLink) {
//     if (matchMedia('screen and (min-width: 1280px)').matches) {
//       this.progressEl.style = `
//         left: ${menuItemLink.parentElement.offsetLeft + menuItemLink.offsetLeft}px;
//         width: ${menuItemLink.offsetWidth}px;
//       `;
//     }
//     else {
//       this.progressEl.style = `
//         top: ${menuItemLink.parentElement.offsetTop + menuItemLink.offsetTop}px;
//         height: ${menuItemLink.offsetHeight}px;
//       `;
//     }
//   }
// }